
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $3001113bb5968f7d$exports = {};
$parcel$extendImportMap({
    "3p1cd": "logo_swgu.9475091d.png",
    "a0ilV": "logo_bga.cfa10d78.avif",
    "6ZLLZ": "logo_tba.60662e1f.png",
    "imGAy": "logo_color.53114b78.png",
    "jZv3H": "logo_s2ss.1d6a5873.png",
    "fvGRQ": "logo_cspc.43affe79.jpeg",
    "hXq2e": "logo_toca.a5c42d75.png",
    "4dMls": "logo_djp.0ea9501e.jpeg",
    "4BrK4": "placeholder_logo.329f327e.png",
    "2aHzZ": "ico_linkedin.5065c34d.png"
});

const $a1ec55fd81849fc9$export$fa1f4c3f2649a9be = `
<div class="relative isolate py-8 px-6 pt-14 lg:px-8">
    <div class="mx-auto mt-8 max-w-screen-2xl sm:mt-12 lg:mt-16 lg:max-w-screen-xl">
        <dl class="grid grid-cols-5 gap-4">
            <dt class="relative col-span-2">
                <h2 class="mb-6 text-left text-base font-semibold leading-7 text-dr-yellow-dark">
                    C O N T A C T
                </h2>
                <h1 class="text-4xl font-bold tracking-tight pb-8 text-dr-dark sm:text-6xl">
                    Let's Connect
                </h1>
                <!-- <div class="text-2xl text-center font-bold">with</div>" -->
                <div class="logoPlaceholder lg"></div>
                <!-- <div class="socialPlaceholder lg pt-20">
                                <a href="https://www.linkedin.com/in/desteni-rivers-757618196">
                                    <img src="assets/static/ico_linkedin.png" alt="LinkedIn" class="h-8 w-auto">
                                </a>
                                <a href="https://www.linkedin.com/in/desteni-rivers-757618196">
                                    <img src="assets/static/ico_linkedin.png" alt="LinkedIn" class="h-8 w-auto">
                                </a>
                            </div> -->
            </dt>
            <dt class="relative col-span-3">
                <form class="space-y-4" id="contact-form">
                    <div class=" grid grid-cols-4 gap-4">
                        <div class="relative col-span-2">
                            <input type='text' placeholder='First name'
                                class="flex w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                id="fname" />
                        </div>
                        <div class="relative col-span-2">
                            <input type='text' placeholder='Last name'
                                class="w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                id="lname" />
                        </div>
                        <div class="relative col-span-2">
                            <input type='email' placeholder='Email address'
                                class="w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                autocomplete="email" id="email" />
                        </div>
                        <div class="relative col-span-2">
                            <input type='tel' placeholder='Phone number (optional)'
                                class="w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                autocomplete="tel" id="phone" />
                        </div>
                        <div class="relative flex items-center col-span-full">
                            <div class="flex flex-wrap gap-6 mt-4">
                                <div class="flex items-center">
                                    <input id="radio1" type="radio" name="subject" class="hidden peer" />
                                    <label for="radio1"
                                        class="relative p-0.5 flex items-center justify-center shrink-0 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-5 h-5 cursor-pointer border-2 border-[#011c2b] rounded-full overflow-hidden">
                                        <span class="border-[4px] border-[#011c2b] rounded-full w-full h-full"></span>
                                    </label>
                                    <p class="text-sm text-slate-600 ml-3">Request for Quote</p>
                                </div>
                                <div class="flex items-center">
                                    <input id="radio2" type="radio" name="subject" class="hidden peer" />
                                    <label for="radio2"
                                        class="relative p-0.5 flex items-center justify-center shrink-0 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-5 h-5 cursor-pointer border-2 border-[#011c2b] rounded-full overflow-hidden">
                                        <span class="border-[4px] border-[#011c2b] rounded-full w-full h-full"></span>
                                    </label>
                                    <p class="text-sm text-slate-600 ml-3">Book a Consultation</p>
                                </div>
                                <div class="flex items-center">
                                    <input id="radio3" type="radio" name="subject" class="hidden peer" />
                                    <label for="radio3"
                                        class="relative p-0.5 flex items-center justify-center shrink-0 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-5 h-5 cursor-pointer border-2 border-[#011c2b] rounded-full overflow-hidden">
                                        <span class="border-[4px] border-[#011c2b] rounded-full w-full h-full"></span>
                                    </label>
                                    <p class="text-sm text-slate-600 ml-3">General Inquiry</p>
                                </div>
                            </div>
                        </div>
                        <div class="relative flex items-center col-span-full">
                            <textarea placeholder='Message' rows="6"
                                class="px-4 pt-3 bg-slate-100 w-full text-sm text-slate-900 border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                id="email-body"></textarea>
                        </div>
                        <button type='submit' id="btn-submit"
                            disabled class="rounded-md bg-dr-btn-dark px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabed:hover:bg-dr-btn-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dr-btn-dark">
                            Send Email
                        </button>
                    </div>
                </form>
            </dt>
        </dl>
    </div>
</div>
`;


////////////////////////////////////////////////
//// TEXT CONTENT
////////////////////////////////////////////////
const $b8869418296450f3$export$4f20597ab32e56d6 = "IMPACTING desteni";
const $b8869418296450f3$var$HERO_HEADLINE = "Want help with your IMPACT? Grant writing, program development, you name it.";
const $b8869418296450f3$var$HERO_HIGHLIGHT = "Hear it first from my clients";
const $b8869418296450f3$var$TAGLINE = "I work with domestic and international nonprofit organizations.";
// const HERO_INTRO = `At ${ORG_NAME}, I believe in the power of community-driven solutions to address systemic inequities and foster holistic wellbeing. Leveraging our expertise in program development, grant writing, consulting, and facilitation, I partner with organizations and communities to co-create innovative, evidence-based initiatives that drive lasting, transformative change.`;
const $b8869418296450f3$var$SERVICES = [
    "Prospect Research",
    "Capital Campaigns",
    "Consulting",
    "Program Development",
    "Grant Writing"
];
const $b8869418296450f3$var$POSITIONS = [
    "Interim Development Director / Manager",
    "Grant Writer"
];
// const APPROACH = ["Trauma-Informed Practices", "Restorative Justice", "Community Engagement", "Holistic Healing"];
// const IMPACT = ["Empowering Organizations", "Strengthening Communities", "Advancing Social Justice", "Fostering Wellbeing"];
const $b8869418296450f3$var$ABOUT = [
    "My Mission",
    "My Team",
    "My Values"
];
// const CONTACT = ["Get in Touch", "Schedule a Consultation"];
// export const HERO_TAGLINE = "Empowering Communities to Drive Lasting Change";
// const heroIntro = `
// Welcome to ${ORG_NAME}, where your vision for change finds its voice and your mission gains momentum. Our team of dedicated professionals is committed to elevating your impact through expert grant writing, strategic nonprofit development, innovative program development, and insightful advisory services. Let’s turn your ideas into action and your goals into achievements. Partner with us to create a brighter future, one grant at a time. 🌟
// Discover the Difference with ${ORG_NAME}:
// Grant Writing: Secure the funding you need with compelling narratives and robust proposals.
// Nonprofit Development: Build a strong foundation for growth with our tailored organizational strategies.
// Program Development: Design and implement programs that resonate with your audience and deliver results.
// Advisory Services: Navigate the complexities of the nonprofit world with our expert guidance.
// `;
// const heroIntro = `
// Welcome to ${ORG_NAME},
//                         where your vision for
//                         change finds its voice and your mission gains momentum.
// Our team of dedicated professionals is
//                         committed to elevating your impact through expert grant writing, strategic nonprofit
//                         development, innovative program development, and insightful advisory services. Let’s turn your
//                         ideas into action and your goals into achievements. Partner with us to create a brighter future,
//                         one grant at a time. 🌟pert guidance.
// `;
////////////////////////////////////////////////
//// URL CONTENT
////////////////////////////////////////////////
const $b8869418296450f3$var$NAV_A = "Home";
const $b8869418296450f3$var$NAV_B = "Services";
const $b8869418296450f3$var$NAV_C = "Clients";
const $b8869418296450f3$var$NAV_D = "About";
const $b8869418296450f3$var$TAG_ABOUT = "#about";
const $b8869418296450f3$var$TAG_CLIENTS = "#clients";
const $b8869418296450f3$var$TAG_CONTACT = "#contact";
const $b8869418296450f3$var$TAG_ORGS = "#orgs";
const $b8869418296450f3$var$TAG_SERVICES = "#services";
const $b8869418296450f3$var$TAG_TOP = "#top";
const $b8869418296450f3$var$ACTION_BOOK = "Book a Call";
// const ACTION_BOOK = "Book a Consulation";
const $b8869418296450f3$var$ACTION_HIGHLiGHT = `See what they say <span aria-hidden="true">&rarr;`;
const $b8869418296450f3$var$ACTION_HERO_ACTION = "Hire me where you need";
const $b8869418296450f3$var$ACTION_HERO_CONTACT = "Consult me";
var $c118fc2d55b9c1b8$exports = {};
$c118fc2d55b9c1b8$exports = $parcel$resolve("3p1cd");


var $108fbe9c31015832$exports = {};
$108fbe9c31015832$exports = $parcel$resolve("a0ilV");


var $e5ad8028acbbd514$exports = {};
$e5ad8028acbbd514$exports = $parcel$resolve("6ZLLZ");


var $e9d8f92ed140d2ad$exports = {};
$e9d8f92ed140d2ad$exports = $parcel$resolve("imGAy");


var $e167c9f156af96ec$exports = {};
$e167c9f156af96ec$exports = $parcel$resolve("jZv3H");


var $4fc75dea9280a792$exports = {};
$4fc75dea9280a792$exports = $parcel$resolve("fvGRQ");


var $d8e6f4859e722ec4$exports = {};
$d8e6f4859e722ec4$exports = $parcel$resolve("hXq2e");


var $e919e24306e272ec$exports = {};
$e919e24306e272ec$exports = $parcel$resolve("4dMls");


const $b8869418296450f3$export$e41bf5c10d222a71 = [
    new URL($c118fc2d55b9c1b8$exports),
    new URL($108fbe9c31015832$exports),
    new URL($e5ad8028acbbd514$exports),
    new URL($e9d8f92ed140d2ad$exports),
    new URL($e167c9f156af96ec$exports),
    new URL($4fc75dea9280a792$exports),
    new URL($d8e6f4859e722ec4$exports),
    new URL($e919e24306e272ec$exports)
];
const $b8869418296450f3$export$7d692f56c88ad1b4 = `
<h3 class="h3 pb-8">Organizations that <i><u>trust</u></i> me</h3>
`;
const $b8869418296450f3$export$fcc5cc40e9289b37 = `
<div class="py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="text-left">
            <h2 class="h2">C L I E N T S</h2>
            <h1 class="text-4xl font-bold tracking-tight text-dr-dark pb-16 sm:text-6xl">The people-centered
                organizations I've supported say it best</h1>
            <dl
                class="grid max-w-xl grid-cols-2 gap-x-2 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-x-12 lg:gap-y-16
                font-body font-normal leading-normal text-black">
                <div class="relative">
                    <dt class="text-xl">
                        Desteni is an idea candidate for any organization. She is hardworking and dedicated.
                        Desteni is consistent in her efforts, advocates for her needs, and takes pride in her
                        work. She was a valued member of my team and I'd be honored to have her on my team
                        again.
                        <div class="mt-4 text-lg text-dr-yellow-dark">Courtney Harris</div>
                        <div class="text-xl text-gray-500">Former Executive Director<br>Soul 2 Soul Sisters
                        </div>
                    </dt>
                </div>
                <div class="relative">
                    <dt class="text-xl">
                        Working with Desteni as my grant writer has been such a grounding and powerful
                        experience, she brings strategy, clarity, and deep care to every part of the process.
                        She understands how to turn vision into language that honors the work, the community,
                        and the impact we are building.
                        <div class="mt-4 text-lg text-dr-yellow-dark">Ariel Ruempolhamer</div>
                        <div class="text-xl text-gray-500">Founder & Executive Director<br>The Black Girl
                            Advocate</div>
                    </dt>
                </div>
                <div class="relative">
                    <dt class="text-xl">
                        Desteni's work is transformative. She has a unique ability to understand our
                        mission and translate it into compelling content that resonates with our audience.
                        <div class="mt-4 italic text-lg text-dr-yellow-dark">Private Client</div>
                        <div class="italic text-xl text-gray-500">Founder<br>Grassroots Organization</div>
                    </dt>
                </div>
            </dl>
        </div>
    </div>
</div>
`;
const $b8869418296450f3$export$c3337f7ff4143d10 = `
<div class="bg-services-pattern bg-dr-overlay bg-blend-multiply bg-cover py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-3xl lg:text-center">
            <h2 class="h2 lite">Desteni does it all</h2>
            <p class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                Contract for <u>services</u>, Contract for <u>positions</u></p>
            <p class="subtitle-light">Whether you need only my services for a few hours at
                a time or you'd like my presence and expertise in a temp position, I'm here for you.</p>
        </div>
        <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
            <h2 class="mb-6 text-center text-base font-semibold leading-7 text-dr-yellow-lighter">S E R V I C E S</h2>
            <dl class="grid max-w-xl grid-cols-2 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-4 lg:gap-y-16">
                <div class="relative pl-16">
                    <dt class="text-base font-semibold leading-7 text-white">
                        <div
                            class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-dr-dark">
                            <svg viewBox="0 0 24 24" version="1.1" xml:space="preserve"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                fill="currentColor">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                </g>
                                <g id="SVGRepo_iconCarrier">
                                    <style type="text/css">
                                        .st0 {
                                            opacity: 0.2;
                                            fill: none;
                                            stroke: currentColor;
                                            stroke-width: 5.000000e-02;
                                            stroke-miterlimit: 10;
                                        }
                                    </style>
                                    <g id="grid_system"></g>
                                    <g id="_icons">
                                        <g>
                                            <path
                                                d="M21.8,4.5c-0.3-0.7-0.9-1.3-1.6-1.6c-1.5-0.6-3.2,0.1-3.9,1.5l-4.6,10.3c-0.4,0.9-0.5,2-0.4,2.9l0.4,2.2 c0.1,0.3,0.3,0.6,0.6,0.7c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4-0.1,0.5-0.2l1.9-1.2c0.9-0.6,1.5-1.3,1.9-2.3l4.6-10.3 C22.1,6,22.1,5.2,21.8,4.5z M15.4,16.3c-0.3,0.6-0.7,1-1.2,1.4l-0.7,0.4l-0.1-0.7c-0.1-0.6,0-1.2,0.2-1.8l3.5-8l1.8,0.7L15.4,16.3 z M20,5.9l-0.2,0.5L18,5.7l0.2-0.5c0.2-0.4,0.5-0.6,0.9-0.6c0.1,0,0.3,0,0.4,0.1C19.7,4.8,19.9,5,20,5.2c0,0,0,0,0,0 C20.1,5.5,20.1,5.7,20,5.9z">
                                            </path>
                                            <path
                                                d="M3,17h4c0.6,0,1-0.4,1-1s-0.4-1-1-1H3c-0.6,0-1,0.4-1,1S2.4,17,3,17z">
                                            </path>
                                            <path
                                                d="M9,19H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h6c0.6,0,1-0.4,1-1S9.6,19,9,19z">
                                            </path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        Grant Writing
                    </dt>
                    <!-- <dd class="mt-2 text-base leading-7 text-gray-300">help your organization access the resources you need to launch and sustain your programs</dd> -->
                </div>
                <div class="relative pl-16">
                    <dt class="text-base font-semibold leading-7 text-white">
                        <div
                            class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-dr-dark">
                            <svg fill="currentColor" height="200px" width="200px" version="1.2"
                                baseProfile="tiny" id="inventory" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 230"
                                xml:space="preserve">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                </g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M180,26.6c-40.4,0-72.8,32.8-72.8,73.2c0,40.2,32.6,72.8,72.8,72.8c40.2,0,73-32.6,73-73C253,59.2,220.4,26.6,180,26.6z M185.5,139.5v11.4h-10.1v-11.1c-8.7,0-17.5-2.3-21.7-4.7l3.7-14.8c4.7,2.3,12,5,19.8,5c8.4,0,12.5-3.7,12.5-8.7 c0-5-4-7.1-13.6-10.9c-13.4-4.7-21.7-11.4-21.7-23.5c0-11.1,7.3-19.8,20.8-22.5v-12h10.1v11.4c8.4,0,14.4,1.7,18.9,4.1l-4.1,14.4 c-3.3-1.4-8.7-3.7-16.1-3.7s-11.4,3.7-11.4,7.3c0,5,4.7,7,14.8,11.1c13.8,5,20.2,12,20.2,23.5C207.2,127.4,200.2,136.1,185.5,139.5z M205.7,213c0,7-5.7,12.6-12.6,12.6h-85.8C97,225.9,85.9,222,78,214.2l-32.3-32.3c-4.1-4.1-9.4-6.2-14.7-6.2H2v-50h54v-0.1 c10,0,20,3.9,27.8,11.5l46.3,46.3c4.9,4.9,4.9,12.8,0,17.7s-12.8,4.9-17.7,0L75,163.9c-1.5-1.7-4.1-1.7-5.7,0 c-1.7,1.7-1.7,4.3,0,5.9l37.2,37.2c3.9,4.1,9.2,6.2,14.7,6.2s10.9-2.3,14.7-6.2c1.9-1.7,3.4-4.1,4.5-6.4H193 C200,200.6,205.7,206.2,205.7,213z">
                                    </path>
                                </g>
                            </svg>
                        </div>
                        Prospect Research
                    </dt>
                    <!-- <dd class="mt-2 text-base leading-7 text-gray-300">help your organization find and qualify donors and improve fundraising efficiency</dd> -->
                </div>
                <div class="relative pl-16">
                    <dt class="text-base font-semibold leading-7 text-white">
                        <div
                            class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-dr-dark">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                </g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M10 19H6.2C5.0799 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H17.8C18.9201 5 19.4802 5 19.908 5.21799C20.2843 5.40973 20.5903 5.71569 20.782 6.09202C21 6.51984 21 7.0799 21 8.2V8.5M9 9.5V8.5M9 9.5H11.0001M9 9.5C7.88279 9.49998 7.00244 9.62616 7.0001 10.8325C6.99834 11.7328 7.00009 12 9.00009 12C11.0001 12 11.0001 12.2055 11.0001 13.1667C11.0001 13.889 11 14.5 9 14.5M9 15.5V14.5M9 14.5L7.0001 14.5M14 10H17M14 20L16.025 19.595C16.2015 19.5597 16.2898 19.542 16.3721 19.5097C16.4452 19.4811 16.5147 19.4439 16.579 19.399C16.6516 19.3484 16.7152 19.2848 16.8426 19.1574L21 15C21.5523 14.4477 21.5523 13.5523 21 13C20.4477 12.4477 19.5523 12.4477 19 13L14.8426 17.1574C14.7152 17.2848 14.6516 17.3484 14.601 17.421C14.5561 17.4853 14.5189 17.5548 14.4903 17.6279C14.458 17.7102 14.4403 17.7985 14.405 17.975L14 20Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </g>
                            </svg>
                        </div>
                        Capital Campaigns
                    </dt>
                    <!-- <dd class="mt-2 text-base leading-7 text-gray-300">help your organization strategically raise a significant amount of money within a specific timeframe for major projects</dd> -->
                </div>
                <div class="relative pl-16">
                    <dt class="text-base font-semibold leading-7 text-white">
                        <div
                            class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-dr-dark">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                </g>
                                <g id="SVGRepo_iconCarrier">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M17.5 13C18.1814 13 18.7678 12.9988 19.2443 13.0473C19.7375 13.0974 20.2228 13.209 20.6667 13.5056C20.9943 13.7245 21.2755 14.0057 21.4944 14.3333C21.791 14.7772 21.9026 15.2625 21.9527 15.7557C22.0001 16.2209 22 16.7907 22 17.4514C22 18.0483 22.0132 18.6497 21.9527 19.2443C21.9026 19.7375 21.791 20.2228 21.4944 20.6667C21.2755 20.9943 20.9943 21.2755 20.6667 21.4944C20.2228 21.791 19.7375 21.9026 19.2443 21.9527C18.7791 22.0001 18.2093 22 17.5486 22C16.9517 22 16.3503 22.0132 15.7557 21.9527C15.2625 21.9026 14.7772 21.791 14.3333 21.4944C14.0057 21.2755 13.7245 20.9943 13.5056 20.6667C13.209 20.2228 13.0974 19.7375 13.0473 19.2443C12.9988 18.7678 13 18.1814 13 17.5C13 16.8186 12.9988 16.2322 13.0473 15.7557C13.0974 15.2625 13.209 14.7772 13.5056 14.3333C13.7245 14.0057 14.0057 13.7245 14.3333 13.5056C14.7772 13.209 15.2625 13.0974 15.7557 13.0473C16.2322 12.9988 16.8186 13 17.5 13Z"
                                        fill="currentColor"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.5 13C7.18141 13 7.76776 12.9988 8.24428 13.0473C8.73752 13.0974 9.22279 13.209 9.66671 13.5056C9.99428 13.7245 10.2755 14.0057 10.4944 14.3333C10.791 14.7772 10.9026 15.2625 10.9527 15.7557C11.0001 16.2209 11 16.7907 11 17.4514C11 18.0483 11.0132 18.6497 10.9527 19.2443C10.9026 19.7375 10.791 20.2228 10.4944 20.6667C10.2755 20.9943 9.99428 21.2755 9.66671 21.4944C9.22279 21.791 8.73752 21.9026 8.24428 21.9527C7.77912 22.0001 7.20932 22 6.54857 22C5.95171 22 5.35034 22.0132 4.75572 21.9527C4.26248 21.9026 3.77721 21.791 3.33329 21.4944C3.00572 21.2755 2.72447 20.9943 2.50559 20.6667C2.20898 20.2228 2.09745 19.7375 2.04727 19.2443C1.99879 18.7678 2 18.1814 2 17.5C2 16.8186 1.99879 16.2322 2.04727 15.7557C2.09745 15.2625 2.20898 14.7772 2.50559 14.3333C2.72447 14.0057 3.00572 13.7245 3.33329 13.5056C3.77721 13.209 4.26248 13.0974 4.75572 13.0473C5.23225 12.9988 5.81858 13 6.5 13Z"
                                        fill="currentColor"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.5 2C7.18141 2 7.76776 1.99879 8.24428 2.04727C8.73752 2.09745 9.22279 2.20898 9.66671 2.50559C9.99428 2.72447 10.2755 3.00572 10.4944 3.33329C10.791 3.77721 10.9026 4.26248 10.9527 4.75572C11.0001 5.22089 11 5.79069 11 6.45143C11 7.04829 11.0132 7.64966 10.9527 8.24428C10.9026 8.73752 10.791 9.22279 10.4944 9.66671C10.2755 9.99428 9.99428 10.2755 9.66671 10.4944C9.22279 10.791 8.73752 10.9026 8.24428 10.9527C7.77912 11.0001 7.20932 11 6.54857 11C5.95171 11 5.35034 11.0132 4.75572 10.9527C4.26248 10.9026 3.77721 10.791 3.33329 10.4944C3.00572 10.2755 2.72447 9.99428 2.50559 9.66671C2.20898 9.22279 2.09745 8.73752 2.04727 8.24428C1.99879 7.76776 2 7.18142 2 6.5C2 5.81858 1.99879 5.23225 2.04727 4.75572C2.09745 4.26248 2.20898 3.77721 2.50559 3.33329C2.72447 3.00572 3.00572 2.72447 3.33329 2.50559C3.77721 2.20898 4.26248 2.09745 4.75572 2.04727C5.23225 1.99879 5.81858 2 6.5 2Z"
                                        fill="currentColor"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M18.5 3C18.5 2.44772 18.0523 2 17.5 2C16.9477 2 16.5 2.44772 16.5 3V5.5H14C13.4477 5.5 13 5.94772 13 6.5C13 7.05228 13.4477 7.5 14 7.5H16.5V10C16.5 10.5523 16.9477 11 17.5 11C18.0523 11 18.5 10.5523 18.5 10V7.5H21C21.5523 7.5 22 7.05228 22 6.5C22 5.94772 21.5523 5.5 21 5.5H18.5V3Z"
                                        fill="currentColor"></path>
                                </g>
                            </svg>
                        </div>
                        Program Development / Consulting
                    </dt>
                    <!-- <dd class="mt-2 text-base leading-7 text-gray-300">help your organization and communities develop impactful programs that address their unique needs</dd> -->
                </div>
            </dl>
        </div>
        <div class="mx-auto mt-8 max-w-2xl sm:mt-20 lg:mt-16 lg:max-w-4xl">
            <h2 class="mb-6 text-center text-base font-semibold leading-7 text-dr-yellow-lighter">P O S I T I O N S</h2>
            <dl class="grid max-w-xl grid-cols-2 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                <div class="relative pl-16">
                    <dt class="text-base font-semibold leading-7 text-white">
                        <div
                            class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-dr-light">
                            <svg fill="bg-dr-dark" viewBox="0 0 14 14" role="img" focusable="false"
                                aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke="currentColor" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                </g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M 6.8718872,12.985621 C 6.6868,12.940599 6.5107171,12.795231 6.4324802,12.62315 c -0.061029,-0.133963 -0.061029,-0.390684 0,-0.523847 0.045021,-0.09805 0.2517186,-0.311547 0.3017421,-0.311547 0.016008,0 0.025012,-0.159075 0.025012,-0.44681 l 0,-0.446711 -0.1432675,0.01201 c -0.7052321,0.05703 -1.2266778,0.16928 -1.6333693,0.351566 l -0.144268,0.06503 0.061029,0.06503 c 0.1926907,0.205797 0.23361,0.512641 0.1002472,0.751354 -0.2489173,0.44581 -0.8869178,0.440607 -1.1161257,-0.01 -0.1757828,-0.344962 -0.031015,-0.735646 0.3901837,-1.052195 0.420198,-0.315949 1.1007185,-0.544257 1.9315098,-0.648206 l 0.1308617,-0.01601 0,-0.5708691 0,-0.5708689 0.6729169,0 0.672817,0 0,0.5708689 0,0.5708691 0.1308616,0.01601 c 1.1780549,0.14777 2.0272549,0.544457 2.3238947,1.085512 0.06403,0.117755 0.07503,0.161876 0.07403,0.323252 -5.01e-4,0.142967 -0.01301,0.210899 -0.05503,0.288936 -0.06403,0.120957 -0.2052968,0.250918 -0.3292552,0.302943 -0.1214572,0.05102 -0.3638714,0.04802 -0.4942328,-0.01 -0.1300613,-0.05302 -0.3196506,-0.258422 -0.3541668,-0.38278 -0.06303,-0.228708 -0.010005,-0.494133 0.1375648,-0.628396 0.034016,-0.03201 0.061029,-0.06503 0.061029,-0.07504 0,-0.01 -0.059028,-0.04302 -0.1308616,-0.07404 -0.4439091,-0.19139 -0.982963,-0.309145 -1.6322689,-0.356568 l -0.1308616,-0.01 0,0.438706 0,0.438607 0.1038489,0.07503 c 0.1925907,0.139866 0.2833335,0.341261 0.2593221,0.575571 -0.039018,0.38118 -0.4107934,0.648606 -0.7773661,0.559364 z M 3.7173013,8.8716829 C 3.4755874,8.8306636 3.2618868,8.6658859 3.1560369,8.4383788 3.0970091,8.3125195 3.0970091,8.303015 3.0970091,7.4701227 l -2.001e-4,-0.8410962 0.3584689,0 0.3584688,0 0.030014,0.2055969 c 0.051024,0.3487642 0.1475696,0.5870765 0.309946,0.762259 0.1389655,0.1498706 0.1822859,0.1605756 0.4183971,0.1035488 0.288636,-0.070033 0.9833632,-0.1670787 1.4280727,-0.2004945 0.2055968,-0.015007 0.6598108,-0.028013 1.0093754,-0.028013 0.3494646,0 0.8036786,0.013006 1.0092754,0.028013 0.4447095,0.033016 1.1395368,0.1309617 1.4279726,0.2004945 0.203796,0.049023 0.207998,0.049023 0.2990409,0 C 9.9834528,7.5781736 10.139126,7.2637255 10.187749,6.8073105 l 0.01701,-0.1557734 0.372575,0 0.372676,0 -0.01,0.8286904 c -0.01001,0.8039787 -0.01001,0.832292 -0.06503,0.953249 -0.110753,0.2405133 -0.311447,0.3913843 -0.578173,0.4345046 -0.19049,0.031015 -6.3998141,0.032015 -6.5811995,0 z M 4.4563494,7.2708288 C 4.4333386,7.1569752 4.0178428,2.5242931 4.018143,2.3790246 4.0187433,2.025258 4.1651122,1.6924012 4.4399417,1.4199729 4.6580444,1.203671 4.8094157,1.1152294 5.079643,1.0461968 c 0.1830862,-0.0470221 0.2800319,-0.049023 1.9270077,-0.049023 1.4575865,4.0019e-4 1.7597288,0.0100048 1.8936919,0.0380179 0.4747237,0.1118526 0.8934209,0.5056381 1.0378889,0.9760597 0.079038,0.2583217 0.071033,0.3914844 -0.1723812,2.8818574 -0.1299612,1.3274253 -0.239913,2.4171386 -0.2444151,2.4216407 0,0 -0.114554,-0.014007 -0.2446152,-0.040019 C 8.7296622,7.1624778 7.7500008,7.078038 6.9941448,7.077938 6.2571976,7.0778379 5.2809378,7.1639785 4.7313789,7.2767316 c -0.1347634,0.028013 -0.2491173,0.050024 -0.2542197,0.050024 -0.010005,0 -0.014007,-0.025012 -0.02101,-0.056026 z M 2.5853681,6.3008719 C 2.4863215,6.245846 2.4223913,6.16941 2.3967793,6.0745653 c -0.035016,-0.1288606 0,-0.23361 0.1204567,-0.348364 0.4588161,-0.4425085 1.2278784,-0.2227049 1.3893544,0.397187 0.02001,0.078037 0.037018,0.1567739 0.037018,0.1744822 0,0.04302 -1.2814036,0.045021 -1.3582398,0 z m 7.4897279,-0.039018 c 0,-0.1118527 0.08404,-0.3179498 0.175282,-0.4384065 0.187189,-0.246116 0.507439,-0.3731758 0.803079,-0.3185501 0.434204,0.080038 0.68032,0.4007888 0.515442,0.6712162 -0.08704,0.1431674 -0.14907,0.1542726 -0.858404,0.1542726 l -0.6363,0 9.01e-4,-0.069033 z">
                                    </path>
                                </g>
                            </svg>
                        </div>
                        Interim Development Director / Manager
                    </dt>
                    <!-- <dd class="mt-2 text-base leading-7 text-gray-300">Quisque est vel vulputate cursus. Risus proin
                    diam nunc commodo. Lobortis auctor congue commodo diam neque.</dd> -->
                </div>
                <div class="relative pl-16">
                    <dt class="text-base font-semibold leading-7 text-white">
                        <div
                            class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-dr-light">
                            <svg fill="bg-dr-dark" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 209 256"
                                enable-background="new 0 0 209 256" xml:space="preserve">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                </g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M99.767,2c13.73,0,24.861,11.131,24.861,24.861s-11.131,24.861-24.861,24.861c-13.73,0-24.861-11.131-24.861-24.861 S86.037,2,99.767,2z M153.535,116.134c1.393-2.019,2.214-4.481,2.227-7.15c0.031-6.83-4.931-12.658-11.742-12.748l-7.911-21.097 l-6.348,2.38l7.018,18.716L94.605,96.27c0.057,0.16-12.833-36.916-14.535-40.943c-3.313-7.84-9.761-12.885-18.171-12.387 c-11.462,0.679-19.185,10.438-23.154,21.213c-7.911,21.471-13.56,57.632-11.269,81.116c1.062,9.392,3.37,17.339,8.67,21.95H17.785 V96.27H2.018V254h15.766v-71.015h75.663l-10.719,53.348c-1.605,7.954,3.541,15.702,11.494,17.308 c0.981,0.198,1.959,0.294,2.923,0.294c6.849,0,12.977-4.815,14.385-11.787l9.377-46.67l12.323,33.046 c2.204,5.91,7.809,9.562,13.767,9.562c1.705,0,3.44-0.299,5.131-0.93c7.602-2.835,11.467-11.295,8.632-18.897l-25.756-69.072 c-2.143-5.748-7.632-9.558-13.765-9.558H80.85v-7.815h110.365v122.122h15.766v-137.8H153.535z">
                                    </path>
                                </g>
                            </svg>
                        </div>
                        Grant Writer
                    </dt>
                    <!-- <dd class="mt-2 text-base leading-7 text-gray-300">Arcu egestas dolor vel iaculis in ipsum
                    mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.</dd> -->
                </div>
            </dl>
        </div>
    </div>
</div>
`;
const $b8869418296450f3$export$7128531d3f25dc8d = `
<div class="relative isolate px-6 pt-14 lg:px-8">
    <div class="mx-auto max-w-4xl py-32 sm:py-48 lg:py-56">
        <div class="hidden sm:mb-8 sm:flex sm:justify-center">
            <div
                class="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-dr-dark/10 hover:ring-dr-dark/20">
                ${$b8869418296450f3$var$HERO_HIGHLIGHT} <a href="${$b8869418296450f3$var$TAG_CLIENTS}"
                    class="font-semibold text-dr-yellow-dark"><span class="absolute inset-0"
                        aria-hidden="true"></span>${$b8869418296450f3$var$ACTION_HIGHLiGHT}</span></a>
            </div>
        </div>
        <div class="text-center">
            <h1 class="h1">${$b8869418296450f3$var$HERO_HEADLINE}</h1>
            <p class="subtitle-dark">${$b8869418296450f3$var$TAGLINE}</p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
            <a href="${$b8869418296450f3$var$TAG_SERVICES}"
            class="rounded-md bg-dr-btn-dark px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-dr-btn-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dr-btn-dark">
                ${$b8869418296450f3$var$ACTION_HERO_ACTION}</a>
            <a href="${$b8869418296450f3$var$TAG_CONTACT}" class="nav-item">${$b8869418296450f3$var$ACTION_HERO_CONTACT} <span
                        aria-hidden="true">\u{2192}</span></a>
            </div>
        </div>
    </div>
</div>
`;
const $b8869418296450f3$export$84243c83965a8aaf = `
<div
    class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
    <button type="button"
        class="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
        <span class="absolute -inset-1.5"></span>
        <span class="sr-only">Book a Consultation</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
        </svg>
    </button>
</div>
`;
const $b8869418296450f3$export$5c49b5485190e709 = `
<header class="absolute inset-x-0 top-0 z-50 ms-4 me-4">
    <nav class="flex items-center justify-between p-6 lg:px-4 sm:px-1" aria-label="Global">
        <div class="flex lg:flex-1 sm:flex-shrink">
            <a href="#top" class="-m-1.5 p-1.5">
                <span class="sr-only">${$b8869418296450f3$export$4f20597ab32e56d6}</span>
                <div class="logoPlaceholder"></div>
            </a>
            <!-- <a href="#" class="hidden sm:flex -m-1.5 p-1.5">
                <span class="text-2xl">${$b8869418296450f3$export$4f20597ab32e56d6}</span>
            </a> -->
        </div>
        <div class="flex lg:gap-x-12 space-x-4">
            <a href="${$b8869418296450f3$var$TAG_TOP}" class="nav-item">${$b8869418296450f3$var$NAV_A}</a>
            <a href="${$b8869418296450f3$var$TAG_SERVICES}" class="nav-item">${$b8869418296450f3$var$NAV_B}</a>
            <a href="${$b8869418296450f3$var$TAG_CLIENTS}" class="nav-item">${$b8869418296450f3$var$NAV_C}</a>
            <a href="${$b8869418296450f3$var$TAG_ORGS}" class="nav-item">${$b8869418296450f3$var$NAV_D}</a>
        </div>
        <div class="hidden lg:flex lg:flex-1 lg:justify-end">
            <a href="${$b8869418296450f3$var$TAG_CONTACT}"
                class="rounded-md bg-dr-btn-dark px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-dr-btn-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dr-btn-dark">
                ${$b8869418296450f3$var$ACTION_BOOK}</a>
            <!-- <a href="#" class="nav-item">${$b8869418296450f3$var$ACTION_BOOK}</a>-->
        </div>
    </nav>
</header>
`; // export const NAV_MOBILE_HTML = `<!-- Mobile menu, show/hide based on menu open state. -->
 // <div class="lg:hidden" role="dialog" aria-modal="true">
 //     <!-- Background backdrop, show/hide based on slide-over state. -->
 //     <div class="fixed inset-0 z-50"></div>
 //     <div
 //         class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-dr-dark/10">
 //         <div class="flex items-center justify-between">
 //             <a href="#" class="-m-1.5 p-1.5">
 //                 <span class="sr-only">${ORG_NAME}</span>
 //                 <div class="logoPlaceholder"></div>
 //                 </a>
 //             <button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-700">
 //                 <span class="sr-only">Close menu</span>
 //                 <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
 //                     stroke="currentColor" aria-hidden="true">
 //                     <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
 //                 </svg>
 //             </button>
 //         </div>
 //         <div class="mt-6 flow-root">
 //             <div class="-my-6 divide-y divide-gray-500/10">
 //                 <div class="space-y-2 py-6">
 //                     <a href="#"
 //                         class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-dr-dark hover:bg-gray-50">Home</a>
 //                     <a href="#"
 //                         class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-dr-dark hover:bg-gray-50">Services</a>
 //                     <a href="#"
 //                         class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-dr-dark hover:bg-gray-50">Blog</a>
 //                     <a href="#"
 //                         class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-dr-dark hover:bg-gray-50">About</a>
 //                 </div>
 //                 <div class="py-6">
 //                     <a href="#"
 //                         class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-dr-dark hover:bg-gray-50">Get
 //                         in Touch</a>
 //                 </div>
 //             </div>
 //         </div>
 //     </div>
 // </div>
 // `;


var $db24840fa9c68a9a$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $540689f746aefe05$exports = {};
// shim for using process in browser
var $540689f746aefe05$var$process = $540689f746aefe05$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $540689f746aefe05$var$cachedSetTimeout;
var $540689f746aefe05$var$cachedClearTimeout;
function $540689f746aefe05$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $540689f746aefe05$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        else $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    } catch (e) {
        $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        else $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    } catch (e) {
        $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    }
})();
function $540689f746aefe05$var$runTimeout(fun) {
    if ($540689f746aefe05$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedSetTimeout === $540689f746aefe05$var$defaultSetTimout || !$540689f746aefe05$var$cachedSetTimeout) && setTimeout) {
        $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $540689f746aefe05$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $540689f746aefe05$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $540689f746aefe05$var$runClearTimeout(marker) {
    if ($540689f746aefe05$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedClearTimeout === $540689f746aefe05$var$defaultClearTimeout || !$540689f746aefe05$var$cachedClearTimeout) && clearTimeout) {
        $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $540689f746aefe05$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $540689f746aefe05$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $540689f746aefe05$var$queue = [];
var $540689f746aefe05$var$draining = false;
var $540689f746aefe05$var$currentQueue;
var $540689f746aefe05$var$queueIndex = -1;
function $540689f746aefe05$var$cleanUpNextTick() {
    if (!$540689f746aefe05$var$draining || !$540689f746aefe05$var$currentQueue) return;
    $540689f746aefe05$var$draining = false;
    if ($540689f746aefe05$var$currentQueue.length) $540689f746aefe05$var$queue = $540689f746aefe05$var$currentQueue.concat($540689f746aefe05$var$queue);
    else $540689f746aefe05$var$queueIndex = -1;
    if ($540689f746aefe05$var$queue.length) $540689f746aefe05$var$drainQueue();
}
function $540689f746aefe05$var$drainQueue() {
    if ($540689f746aefe05$var$draining) return;
    var timeout = $540689f746aefe05$var$runTimeout($540689f746aefe05$var$cleanUpNextTick);
    $540689f746aefe05$var$draining = true;
    var len = $540689f746aefe05$var$queue.length;
    while(len){
        $540689f746aefe05$var$currentQueue = $540689f746aefe05$var$queue;
        $540689f746aefe05$var$queue = [];
        while(++$540689f746aefe05$var$queueIndex < len)if ($540689f746aefe05$var$currentQueue) $540689f746aefe05$var$currentQueue[$540689f746aefe05$var$queueIndex].run();
        $540689f746aefe05$var$queueIndex = -1;
        len = $540689f746aefe05$var$queue.length;
    }
    $540689f746aefe05$var$currentQueue = null;
    $540689f746aefe05$var$draining = false;
    $540689f746aefe05$var$runClearTimeout(timeout);
}
$540689f746aefe05$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $540689f746aefe05$var$queue.push(new $540689f746aefe05$var$Item(fun, args));
    if ($540689f746aefe05$var$queue.length === 1 && !$540689f746aefe05$var$draining) $540689f746aefe05$var$runTimeout($540689f746aefe05$var$drainQueue);
};
// v8 likes predictible objects
function $540689f746aefe05$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$540689f746aefe05$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$540689f746aefe05$var$process.title = 'browser';
$540689f746aefe05$var$process.browser = true;
$540689f746aefe05$var$process.env = {};
$540689f746aefe05$var$process.argv = [];
$540689f746aefe05$var$process.version = ''; // empty string to avoid regexp issues
$540689f746aefe05$var$process.versions = {};
function $540689f746aefe05$var$noop() {}
$540689f746aefe05$var$process.on = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.addListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.once = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.off = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeAllListeners = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.emit = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependOnceListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.listeners = function(name) {
    return [];
};
$540689f746aefe05$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$540689f746aefe05$var$process.cwd = function() {
    return '/';
};
$540689f746aefe05$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$540689f746aefe05$var$process.umask = function() {
    return 0;
};


'use strict';
function $db24840fa9c68a9a$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $db24840fa9c68a9a$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $db24840fa9c68a9a$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $db24840fa9c68a9a$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $540689f746aefe05$exports.cwd();
                path = cwd;
            }
            $db24840fa9c68a9a$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $db24840fa9c68a9a$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $db24840fa9c68a9a$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $db24840fa9c68a9a$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $db24840fa9c68a9a$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $db24840fa9c68a9a$var$assertPath(from);
        $db24840fa9c68a9a$var$assertPath(to);
        if (from === to) return '';
        from = $db24840fa9c68a9a$var$posix.resolve(from);
        to = $db24840fa9c68a9a$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $db24840fa9c68a9a$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $db24840fa9c68a9a$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$db24840fa9c68a9a$var$posix.posix = $db24840fa9c68a9a$var$posix;
$db24840fa9c68a9a$exports = $db24840fa9c68a9a$var$posix;


// LOADERS
document.addEventListener('DOMContentLoaded', ()=>{
    $a626f7575c7e4e47$var$renderHero();
    $a626f7575c7e4e47$var$renderSvcs();
    $a626f7575c7e4e47$var$renderClients();
    $a626f7575c7e4e47$var$renderContactForm();
    $a626f7575c7e4e47$var$renderNav();
    $a626f7575c7e4e47$var$renderLogos();
    $a626f7575c7e4e47$var$renderOrgs();
    $a626f7575c7e4e47$var$renderBtnChat();
});
// document.getElementById("contact-form").addEventListener("submit", (event) => {
//     const contactForm = event.target
//     // validateContactForm(contactForm) || event.preventDefault();
// });
// VALIDATION
// function validateContactForm(form) {
//     const names = form.querySelector('input[type="text"]').value;
//     const email = form.querySelector('input[type="email"]').value;
//     const phone = form.querySelector('input[type="tel"]').value;
//     const nameRegex = /[a-zA-Z][a-zA-Z\s]+$/;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\+?[0-9\s\-()]{7,}$/;
//     let errorMessage = [];
//     nameRegex.test(names[0]) || (errorMessage.push('First name must contain only letters and spaces.'));
//     nameRegex.test(names[1]) || (errorMessage.push('Last name must contain only letters and spaces.'));
//     emailRegex.test(email) || (errorMessage.push('Email must be in a valid format.'));
//     if (phone !== '' && !phoneRegex.test(phone)) {
//         errorMessage.push('Phone number must be in a valid format.');
//     }
//     if (errorMessage) {
//         console.log(errorMessage);
//         displayError(form, errorMessage);
//         return false;
//     }
//     return true;
// function displayError(form, message) {
//     let errorDiv = form.querySelector('.error-message');
//     if (!errorDiv) {
//         errorDiv = document.createElement('div');
//         errorDiv.classList.add('error-message', 'text-red-500', 'text-sm', 'mt-2');
//         for (err in message) {
//             const paragraph = document.createElement('p');
//             paragraph.textContent = err;
//             errorDiv.appendChild(paragraph);
//             console.log(errorDiv);
//         }
//         form.appendChild(errorDiv);
//     }
// }
// RENDERING HTML
function $a626f7575c7e4e47$var$renderSvcs() {
    const svcs = document.getElementById("services");
    svcs.innerHTML = (0, $b8869418296450f3$export$c3337f7ff4143d10);
}
function $a626f7575c7e4e47$var$renderOrgs() {
    const orgs = document.getElementById("orgs");
    orgs.innerHTML = (0, $b8869418296450f3$export$7d692f56c88ad1b4);
    orgs.classList.add("mx-auto", "max-w-7xl", "py-16", "sm:py-16", "px-6", "lg:px-8");
    const logosContainer = document.createElement("div");
    logosContainer.classList.add("flex", "flex-wrap", "justify-center", "gap-12");
    for (const file of (0, $b8869418296450f3$export$e41bf5c10d222a71)){
        const orgLogo = document.createElement("img");
        orgLogo.classList.add("org", "h-32", "w-auto");
        orgLogo.src = file;
        logosContainer.appendChild(orgLogo);
    }
    orgs.appendChild(logosContainer);
}
function $a626f7575c7e4e47$var$renderClients() {
    const clients = document.getElementById("clients");
    clients.innerHTML = (0, $b8869418296450f3$export$fcc5cc40e9289b37);
    clients.classList.add("bg-community-pattern", "bg-dr-overlay-light", "bg-blend-soft-light", "bg-cover", "bg-center", "py-16", "sm:py-32");
}
function $a626f7575c7e4e47$var$renderContactForm() {
    const contact = document.getElementById("contact");
    contact.classList.add("bg-white");
    contact.innerHTML = (0, $a1ec55fd81849fc9$export$fa1f4c3f2649a9be);
}
function $a626f7575c7e4e47$var$renderBtnChat() {
    const btnChat = document.getElementById("btnChat");
    btnChat.innerHTML = (0, $b8869418296450f3$export$84243c83965a8aaf);
}
function $a626f7575c7e4e47$var$renderHero() {
    const hero = document.getElementById("hero");
    hero.innerHTML = (0, $b8869418296450f3$export$7128531d3f25dc8d);
}
function $a626f7575c7e4e47$var$renderNav() {
    const nav = document.getElementById("nav");
    nav.innerHTML = (0, $b8869418296450f3$export$5c49b5485190e709);
}
var $f63e0957a71bbb42$exports = {};
$f63e0957a71bbb42$exports = $parcel$resolve("4BrK4");


function $a626f7575c7e4e47$var$renderLogos() {
    var logoDivs = document.getElementsByClassName("logoPlaceholder");
    for(var i = 0; i < logoDivs.length; i++){
        const logo = document.createElement("img");
        logo.classList.add("logo");
        if (logoDivs[i].classList.contains("lg")) logo.classList.add("h-20", "w-auto");
        else logo.classList.add("h-12", "w-auto");
        logo.src = new URL($f63e0957a71bbb42$exports);
        logoDivs[i].innerHTML = ""; // Clear existing content
        logoDivs[i].appendChild(logo); // Add the image to the div
    }
}
var $4ba52adc88ae08e4$exports = {};
$4ba52adc88ae08e4$exports = $parcel$resolve("2aHzZ");


function $a626f7575c7e4e47$var$renderSocials() {
    var divs = document.getElementsByClassName("socialPlaceholder");
    for(var i = 0; i < divs.length; i++){
        const icon = document.createElement("img");
        icon.classList.add("icon");
        if (divs[i].classList.contains("lg")) icon.classList.add("h-20", "w-auto");
        else icon.classList.add("h-12", "w-auto");
        icon.src = new URL($4ba52adc88ae08e4$exports);
        divs[i].innerHTML = ""; // Clear existing content
        divs[i].appendChild(icon); // Add the image to the div
    }
}


//# sourceMappingURL=riversimpact.org.ee181930.js.map
